// /api/auth-logout accepts only a same-origin POST (CSRF), so leave through a top-level form submission.
export function logout(returnTo: string): void {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = `/api/auth-logout?returnTo=${encodeURIComponent(returnTo)}`
  document.body.appendChild(form)
  form.submit()
}
